// ---------------------------------------------------------------------------
// DB change notifications. Every write through execute() (and lifecycle events
// like imports) bumps a version counter; screens subscribe via useDbVersion()
// and include the version in their useMemo deps, so a write made on one screen
// refreshes reads on every other screen. A deliberately tiny alternative to a
// full query-cache library for a single-user local app.
// ---------------------------------------------------------------------------

import { useSyncExternalStore } from 'react';

type Listener = () => void;

let version = 0;
const listeners = new Set<Listener>();

export function notifyDbChanged(): void {
  version++;
  for (const listener of listeners) listener();
}

export function subscribeDb(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getDbVersion(): number {
  return version;
}

/** Re-renders the component whenever any repository write happens. */
export function useDbVersion(): number {
  return useSyncExternalStore(subscribeDb, getDbVersion, getDbVersion);
}
